import { API_REQUEST, GET_ELS_LOOKUPS, GET_LOOKUPS, GET_AFFORDABLE_HOUSING_RATES } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

// Get ELS lookups for dropdown, wizard
export const getElsLookups = (propCode: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/get-lookups/unit-dropdowns/${propCode}`,
        next: GET_ELS_LOOKUPS,
        method: 'GET',
        authorization: true
    }
});

// Fetch ELS income attribute lookups
export const getLookups = (lookupType: string): AppAction => ({
    type: API_REQUEST,
    payload: Object.assign({
        url: `/income/get-lookups/${lookupType}`,
        next: GET_LOOKUPS,
        method: 'GET',
        authorization: true
    })

});

// Fetch affordable housing rates
export const getAffordableHousingRates = (campaignYear: string, municipalityCode: string): AppAction => ({
    type: API_REQUEST,
    payload: Object.assign({
        url: `/income/get-affordable-housing-rates/${campaignYear}/${municipalityCode}`,
        next: GET_AFFORDABLE_HOUSING_RATES,
        method: 'GET',
        authorization: true
    })

});

